<template>
  <div
    class="input-group mb-3 mt-1"
  >
    <input
        type="file"
        :accept="acceptMimeType"
        :multiple="isMultiple"
        class="form-control"
        @input="preProcessUpload($event)"

    />

    <button
        @click.prevent="processUpload()"
        class="btn btn-primary"
        :disabled="upload.button.disabled"
    >
      <i class="bi bi-upload me-1"/>
      upload
    </button>

  </div>


  <div
    v-if="isProgressUpload"
  >
    <ul>
      <li v-for="file in form.files" :key="file.id">
        <small>
          {{file.data.name}} (size: {{ displayFileSize(file.data.size) }})
        </small>


        <div
          v-if="file.is_uploading"
        >
          Prave nahravam soubor, {{getProgressProcent(file)}}%
          <div
              class="progress progress-bar progress-bar-striped progress-bar-animated"
              :style="'width: ' + getProgressProcent(file) + '%;'"
          >
            &nbsp;
          </div>
        </div>

        <div
            v-if="file.is_finished"
            class="text-success"
        >
          <i class="bi bi-check-circle me-1"/>
          Hotovo
        </div>

<!--
        <pre>{{file}}</pre>
-->
      </li>
    </ul>


  </div>

  <!--
    <pre>{{modelValue}}</pre>
    <pre>{{acceptMimeType}}</pre
    [fileAttachmentInfo]<br/>

    <pre>{{info}}</pre>
    -->

</template>
<script>

import axios from "axios";

export default {
  name: "fileAttachmentUpload",
  props: {
    "modelValue": {
      type: [ Number, Object],
      required: false,

      default: null
    },
    "acceptMimeType": {
      type: [String],
      required: false,
      default: '*/*'
    },
    "isMultiple": {
      type: [Boolean],
      required: false,
      default: true
    },
    "isProgressUpload": {
      type: [Boolean],
      required: false,
      default: true
    },

  },
  components: {

  },
  emits: ['update:modelValue'],
  data() {
    return {
      CHUNK_SIZE: 0.25 * 1024 * 1024,
      inputModel: [],
      file: null,
      upload: {
        button: {
          disabled: true,
        }
      },
      form: {
        status: null,
        files: [],
        error: null,
      }
    }
  },
  computed: {

  },
  mounted() {

  },
  created() {

  },

  methods: {
    getProgressProcent(file) {
      if(
          file.progressIndicator
      ){
        const total = Object.values(file.progressIndicator).reduce((sum, value) => sum + value, 0);
        return (total/Object.keys(file.progressIndicator).length).toFixed(1);
      }else{
        return 0;
      }
    },
    displayFileSize(bajty, desetinnáMista = 2) {
      if (bajty === 0) return '0 B';

      const k = 1024;
      const dm = desetinnáMista < 0 ? 0 : desetinnáMista;
      const jednotky = ['B', 'KB', 'MB', 'GB', 'TB', 'PB'];

      // Určíme index jednotky pomocí logaritmu
      const i = Math.floor(Math.log(bajty) / Math.log(k));

      // Ošetření pro případ, že by byl soubor větší než dostupné jednotky
      const indexJednotky = i < jednotky.length ? i : jednotky.length - 1;

      // Spočítáme finální hodnotu a zaokrouhlíme
      const hodnota = parseFloat((bajty / Math.pow(k, indexJednotky)).toFixed(dm));

      return `${hodnota} ${jednotky[indexJednotky]}`;
    },
    preProcessUpload(event) {
      this.form.files = [];
      for(const file of event.target.files) {
        //TODO nejaka validace?
        //console.log('dev preUpload FILE', file)
        this.form.files.push(
            {
              progress: 0,
              data: file
            }
        );
      }
      this.upload.button.disabled = false;
    },
    processUpload() {
      this.upload.button.disabled = true;
      for(const file of this.form.files) {
        this.uploadChunkOneFile(file);
      }

      //console.log('dev preUpload', this.form)
    },
    async uploadChunkOneFile(file) {
      this.abortController = new AbortController();

      const totalChunks = Math.ceil(file.data.size / this.CHUNK_SIZE);
      //const fileId = `${Date.now()}-${file.name}`; // Unikátní ID pro server
      const fileId = file.data.name;

      file.is_uploading = true;
      file.progressIndicator = {};
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        file.progressIndicator[chunkIndex] = 0;
      }


      try {
        for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
          if (!file.is_uploading) break;

          const start = chunkIndex * this.CHUNK_SIZE;
          const end = Math.min(start + this.CHUNK_SIZE, file.data.size);

          // Vyřízneme kousek souboru
          const chunk = file.data.slice(start, end);

          const formData = new FormData();
          formData.append('chunk', chunk);
          formData.append('chunkIndex', chunkIndex);
          formData.append('totalChunks', totalChunks);
          formData.append('fileId', fileId);
          formData.append('fileName', file.data.name);

          axios.defaults.baseURL = this.getBaseRoot();
          axios({
            method: this.getApiConfig('file.uploadChunk.method'),
            url: this.getApiConfig('file.uploadChunk.path'),
            data: formData,
            withCredentials: true,
            headers: this.getRequestHeaderUpload(),
            signal: this.abortController.signal,
            onUploadProgress: (progressEvent) => {
              if (!progressEvent.total) {
                return;
              }
              const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              file.progressIndicator[chunkIndex] = percent;
            },
          }).then((res) => {

            //console.log('[htmlEditor.loadCustomButtons] RES',  res.data.response)

            if(
                res.data.response.id
            ) {
              file.is_finished = true;
              file.is_uploading = false;
              this.inputModel.push(res.data.response.id);
            }


            if(
                typeof res.data.response.file_uploaded_path != "undefined"
                && res.data.response.file_uploaded_path
            ) {
              this.is_finished = true;
              this.is_uploading = false;
              //this.inputModel = res.data.response.file_uploaded_path;

            }

            //console.log('[htmlEditor.loadCustomButtons] RES', res.data)

          }).catch(function(err){
            console.log('[htmlEditor.loadCustomButtons] ERR',  err )
          })

          console.log('dev uploadChunkOneFile DEV', this.getApiConfig('file.uploadChunk.path'), formData)

        }
      } catch (error) {
        if (axios.isCancel(error)) {
          this.statusText = 'Nahrávání bylo zrušeno uživatelem.';
        } else {
          console.error(error);
          this.statusText = 'Během nahrávání došlo k chybě.';
        }

        file.isUploading = false;
      }


      //console.log('dev uploadChunkOneFile X', fileId, totalChunks)
    }
  },

  watch: {
    inputModel: {
      handler(newVal, oldVal) {
        console.log('dev FILE watch inputModel', newVal, oldVal)
        //newVal.ad = this.ad;
        this.$emit('update:modelValue', newVal )
      },
      deep: true,
      immediate: true
    },
  },
};
</script>